import Icon from '../components/Icon.vue'

Icon.register({
  'chess-bishop': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M8 287.9c0-73.4 59.8-181.1 112.6-225.4-14-3.4-24.6-15.5-24.6-30.5 0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32 0 15-10.6 27.1-24.6 30.5 24.4 20.5 50.1 54.7 70.9 92.6l-107.9 107.9c-1.3 1.3-2.3 3.8-2.3 5.7 0 1.8 1 4.4 2.3 5.7l11.3 11.3c1.3 1.3 3.8 2.3 5.7 2.3s4.4-1 5.7-2.3l100.3-100.3c16 35.5 26.7 71.9 26.7 102.6 0 51.6-22.1 73.8-56 84.6v43.5h-192v-43.5c-33.9-10.8-56-33-56-84.6zM304 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-288c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chess-bishop.js
// module id = 1177
// module chunks = 0